export default (stateSetter) => (value) => {
  stateSetter(value);
  return value;
};
